import { ICompanyExposure } from '@aqx-core/common/api/dealer/model';

export enum EDealerTab {
  COMPANY_EXPOSURE = 'COMPANY_EXPOSURE'
}

export enum EPositionType {
  BUY = 'BUY',
  SELL = 'SELL'
}

export interface IDisplayCompanyExposureSingle {
  symbol: string;
  type: 'single';
  position: ICompanyExposure;
}

export interface IDisplayCompanyExposureAggregated {
  symbol: string;
  type: 'aggregated';
  netPosition: ICompanyExposure;
  buyPosition: ICompanyExposure;
  sellPosition: ICompanyExposure;
}

export type ICompanyExposureRowData = IDisplayCompanyExposureSingle | IDisplayCompanyExposureAggregated;

export interface ICompanyExposurePositionMap {
  buyPosition?: ICompanyExposure;
  sellPosition?: ICompanyExposure;
  netPosition?: ICompanyExposure;
}

export type TDealerExposurePositionRowType = keyof ICompanyExposurePositionMap;

export enum ECompanyExposureSymbolType {
  FOREX = 'FOREX',
  SHARE = 'SHARE',
  COM = 'COM',
  INDEX = 'INDEX',
  CRYPTO = 'CRYPTO',
  OTHER = 'OTHER',
  ALL = 'ALL',
  FUTURES = 'FUTURES',
  OPTIONS = 'OPTIONS',
  EQUITIES = 'EQUITIES',
  ETFS = 'ETFS'
}

export type TCompanyExposureLiveFields =
  | 'latestPrice'
  | 'profit'
  | 'units'
  | 'lotSize'
  | 'latestTradeTime'
  | 'openPrice'
  | 'totalExposure';
